var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { qboui } from '@quandis/qbo4.ui';
export const mainmenuMap = new Map();
mainmenuMap.set('defaultLayout', (component) => {
    return html `
<nav class="qbo-main-menu">
    <img src="${component.logoPath}"></img>
    <span>Quandis Business Objects</span>
    <menu>
        <li>
            <qbo-menu type="mega">
                <span><svg class="label"><use href="${component.imagePath}#house"></svg> <svg class="icon toggle"><use href="${component.imagePath}#caret-down"></svg></span>
                <aside>
                    <header>
                        <svg><use href="${component.imagePath}#house"></svg>
                        <span>Home Pages</span>
                    </header>
                    <p>Select one of the following home pages to view the corresponding dashboard.</p>
                    <div class="qbo-row">
                        <div class="qbo-card qbo-card-left">
                            <h3 class="title">Financial Services</h3>
                            <p class="detail">Manage and analyze all mortgage and credit related data.</p>
                            <div class="qbo-row">
                                <div class="qbo-col qbo-col-noborder">
                                    <a href="/api/CreditReport/Home">Credit Reports</a>
                                    <br/>
                                    <a href="/api/Listing/Home">Listings</a>
                                    <br/>
                                    <a href="/api/Loan/Home">Loans</a>
                                    <br/>
                                    <a href="/api/Offer/Home">Offers</a>
                                    <br/>
                                    <a href="/api/Property/Home">Properties</a>
                                </div>
                                <div class="qbo-col qbo-col-noborder">
                                    <details>
                                        <summary><svg class="label"><use href="${component.imagePath}#folder2-open"></svg> Processes</summary>
                                        <a href="/api/Process/Home">Processes</a>
                                        <br/>
                                        <a href="/api/Auction/Home">Auctions</a>
                                        <br/>
                                        <a href="/api/Bankruptcy/Home">Bankruptcies</a>
                                        <br/>
                                        <a href="/api/BidAtSale/Home">Bid At Sales</a>
                                        <br/>
                                        <a href="/api/CashForKeys/Home">Cash For Keys</a>
                                        <br/>
                                        <a href="/api/Closing/Home">Closings</a>
                                        <br/>
                                        <a href="/api/Deal/Home">Deals</a>
                                        <br/>
                                        <a href="/api/DeedInLieu/Home">Deeds In Lieu</a>
                                        <br/>
                                        <a href="/api/Deficiency/Home">Deficiencies</a>
                                        <br/>
                                        <a href="/api/Eviction/Home">Evictions</a>
                                        <br/>
                                        <a href="/api/Foreclosure/Home">Foreclosures</a>
                                        <br/>
                                        <a href="/api/InsurancePolicy/Home">Insurance Policies</a>
                                        <br/>
                                        <a href="/api/Litigation/Home">Litigations</a>
                                        <br/>
                                        <a href="/api/LoanModification/Home">Loan Modifications</a>
                                        <br/>
                                        <a href="/api/NoteSale/Home">Note Sales</a>
                                        <br/>
                                        <a href="/api/PropertyInspection/Home">Property Inspections</a>
                                        <br/>
                                        <a href="/api/Reo/Home">REOs</a>
                                        <br/>
                                        <a href="/api/ShortSale/Home">Short Sales</a>
                                        <br/>
                                        <a href="/api/SuitOnNote/Home">Suit On Notes</a>
                                        <br/>
                                        <a href="/api/Title/Home">Titles</a>
                                        <br/>
                                        <a href="/api/Valuation/Home">Valuations</a>
                                    </details>
                                </div>
                            </div>
                        </div>
                        <div class="qbo-card">
                            <h3 class="title">Workforce Management</h3>
                            <p class="detail">Import data, complete exception tasks and run reports.</p>
                            <div class="qbo-row">
                                <div class="qbo-col qbo-col-noborder">
                                    <svg class="label"><use href="${component.imagePath}#database-up"></svg>
                                    <a href="/api/ImportFile/Home">Import Files</a>
                                    <br/>
                                    <svg class="label"><use href="${component.imagePath}#database-down"></svg>
                                    <a href="/api/ReportRequest/Home">Reports</a>
                                    <br/>
                                    <svg class="label"><use href="${component.imagePath}#list-task"></svg>
                                    <a href="/api/ImportForm/Home">Tasks</a>
                                    <br/>
                                    <svg class="label"><use href="${component.imagePath}#diagram-2"></svg>
                                    <a href="/api/Decision/Home">Workflows</a>
                                    <br/>
                                    <svg class="label"><use href="${component.imagePath}#list-check"></svg>
                                    <a href="/api/SmartWorklist/Home">Worklists</a>
                                </div>
                            </div>
                        </div>
                        <div class="qbo-card qbo-card-right">
                            <h3 class="title">Miscellaneous</h3>
                            <p class="detail">Additional modules to support workflow processing and data analysis.</p>
                            <div class="qbo-row">
                                <div class="qbo-col qbo-col-noborder">
                                    <details>
                                        <summary><svg class="label"><use href="${component.imagePath}#person-rolodex"></use></svg> Contacts</summary>
                                        <a href="/api/Borrower/Home">Borrowers</a>
                                        <br/>
                                        <a href="/api/Broker/Home">Brokers</a>
                                        <br/>
                                        <a href="/api/Contact/Home">Contacts</a>
                                        <br/>
                                        <a href="/api/Court/Home">Courts</a>
                                        <br/>
                                        <a href="/api/Organization/Home">Organizations</a>
                                    </details>
                                    <svg class="label"><use href="${component.imagePath}#file-earmark"></svg>
                                    <a href="/api/Attachment/Home">Documents</a>
                                    <br/>
                                    <svg class="label"><use href="${component.imagePath}#currency-dollar"></svg>
                                    <a href="/api/Ledger/Home">Ledgers</a>
                                    <br/>
                                    <svg class="label"><use href="${component.imagePath}#envelope"></svg>
                                    <a href="/api/Message/Home">Messages</a>
                                    <br/>
                                    <svg class="label"><use href="${component.imagePath}#file-spreadsheet"></svg>
                                    <a href="/api/Score/Home">Scores</a>
                                </div>
                                <div class="qbo-col qbo-col-noborder">
                                    <svg class="label"><use href="${component.imagePath}#bucket"></svg>
                                    <a href="/api/Bucket/Home">Buckets</a>
                                    <br/>
                                    <svg class="label"><use href="${component.imagePath}#tag"></svg>
                                    <a href="/api/Collection/Home">Labels</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </aside>
            </qbo-menu>
        </li>
        <li>
            <qbo-menu type="mega">
                <span><svg class="label"><use href="${component.imagePath}#gear"></svg> <svg class="icon toggle"><use href="${component.imagePath}#caret-down"></svg></span>
                <aside>
                    <header>
                        <svg><use href="${component.imagePath}#gear"></svg>
                        <span>System Configuration</span>
                    </header>
                    <p>Manage security, rules, templates and system settings.</p>
                    <div class="qbo-row">
                        <div class="qbo-card qbo-card-left">
                            <h3 class="title">Security</h3>
                            <p class="detail">Manage users, system roles, security access and IP address restrictions.</p>
                            <div class="qbo-row">
                                <div class="qbo-col qbo-col-noborder">
                                    <svg class="label"><use href="${component.imagePath}#person"></svg>
                                    <a href="/api/Person/Home">User Accounts</a>
                                    <br/>
                                    <svg class="label"><use href="${component.imagePath}#person-lock"></svg>
                                    <a href="/api/SystemRole/Home">Roles</a>
                                </div>
                                <div class="qbo-col qbo-col-noborder">
                                    <svg class="label"><use href="${component.imagePath}#lock"></svg>
                                    <a href="/api/ObjectAccess/Home">Group Access</a>
                                </div>
                                <div class="qbo-col qbo-col-noborder">
                                    <svg class="label"><use href="${component.imagePath}#arrow-left-right"></svg>
                                    <a href="/api/SystemAddress/Home">IP Addresses</a>
                                </div>
                            </div>
                        </div>
                        <div class="qbo-card qbo-card-right">
                            <h3 class="title">Rules</h3>
                            <p class="detail">Manage rules matrices, linked objects and business rule plugins.</p>
                            <div class="qbo-row">
                                <div class="qbo-col qbo-col-noborder">
                                    <svg class="label"><use href="${component.imagePath}#grid-3x3-gap"></svg>
                                    <a href="/api/Matrix/Home">Matrices</a>
                                </div>
                                <div class="qbo-col qbo-col-noborder">
                                    <svg class="label"><use href="${component.imagePath}#flag"></svg>
                                    <a href="/api/BusinessRule/Home">Business Rules</a>
                                </div>
                                <div class="qbo-col qbo-col-noborder">
                                    <svg class="label"><use href="${component.imagePath}#link-45deg"></svg>
                                    <a href="/api/ObjectLink/Home">Linked Objects</a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="qbo-row qbo-row-subsequent">
                        <div class="qbo-card qbo-card-left">
                            <h3 class="title">Templates</h3>
                            <p class="detail">Manage templates used for workflow and data processing.</p>
                            <div class="qbo-row">
                                <div class="qbo-col qbo-col-noborder">
                                    <svg class="label"><use href="${component.imagePath}#bucket"></svg>
                                    <a href="/api/BucketTemplate/Home">Buckets</a>
                                    <br/>
                                    <svg class="label"><use href="${component.imagePath}#person-rolodex"></svg>
                                    <a href="/api/ContactTemplate/Home">Contacts</a>
                                    <br/>
                                    <svg class="label"><use href="${component.imagePath}#file-earmark"></svg>
                                    <a href="/api/AttachmentTemplate/Home">Documents</a>
                                    <br/>
                                    <svg class="label"><use href="${component.imagePath}#database-up"></svg>
                                    <a href="/api/ImportFileTemplate/Home">Import Files</a>
                                    <br/>
                                    <svg class="label"><use href="${component.imagePath}#tag"></svg>
                                    <a href="/api/CollectionTemplate/Home">Labels</a>
                                </div>
                                <div class="qbo-col qbo-col-noborder">
                                    <svg class="label"><use href="${component.imagePath}#currency-dollar"></svg>
                                    <a href="/api/LedgerTemplate/Home">Ledgers</a>
                                    <br/>
                                    <svg class="label"><use href="${component.imagePath}#envelope"></svg>
                                    <a href="/api/MessageTemplate/Home">Messages</a>
                                    <br/>
                                    <svg class="label"><use href="${component.imagePath}#folder2-open"></svg>
                                    <a href="/api/ProcessTemplate/Home">Processes</a>
                                    <br/>
                                    <svg class="label"><use href="${component.imagePath}#database-down"></svg>
                                    <a href="/api/Report/Home">Reports</a>
                                    <br/>
                                    <svg class="label"><use href="${component.imagePath}#file-spreadsheet"></svg>
                                    <a href="/api/ScoreTemplate/Home">Scores</a>
                                </div>
                                <div class="qbo-col qbo-col-noborder">
                                    <svg class="label"><use href="${component.imagePath}#shield-lock"></svg>
                                    <a href="/api/SecurityAccessTemplate/Home">Security Access</a>
                                    <br/>
                                    <svg class="label"><use href="${component.imagePath}#list-task"></svg>
                                    <a href="/api/ImportFormTemplate/Home">Tasks</a>
                                    <br/>
                                    <svg class="label"><use href="${component.imagePath}#diagram-2"></svg>
                                    <a href="/api/DecisionTemplate/Home">Workflows</a>
                                    <br/>
                                    <svg class="label"><use href="${component.imagePath}#pause"></svg>
                                    <a href="/api/DecisionDelayTemplate/Home">Workflow Holds</a>
                                    <br/>
                                    <svg class="label"><use href="${component.imagePath}#list-check"></svg>
                                    <a href="/api/SmartWorklistTemplate/Home">Worklists</a>
                                </div>
                            </div>
                        </div>
                        <div class="qbo-card qbo-card-right">
                            <h3 class="title">System</h3>
                            <p class="detail">Advanced system configuration and settings.</p>
                            <div class="qbo-row">
                                <div class="qbo-col qbo-col-noborder">
                                    <a href="/api/Calendar/Home">Calendars</a>
                                    <br/>
                                    <a href="/api/ConfigurationEntry/Home">Configuration Entries</a>
                                    <br/>
                                    <a href="/api/Database/Home">Data Tuning</a>
                                    <br/>
                                    <a href="/api/HealthCheck/Home">Health Checks</a>
                                    <br/>
                                    <a href="/api/Logging/Home">Logging</a>
                                </div>
                                <div class="qbo-col qbo-col-noborder">
                                    <a href="/api/ObjectConfiguration/Home">Modules</a>
                                    <br/>
                                    <a href="/api/ImportFile/PackageList">Packages</a>
                                    <br/>
                                    <a href="/api/Queue/Home">Queuing</a>
                                    <br/>
                                    <a href="/api/CustomRoute/Home">Routes</a>
                                    <br/>
                                    <a href="/api/Schedule/Home">Schedules</a>
                                </div>
                                <div class="qbo-col qbo-col-noborder">
                                    <a href="/api/State/Home">States</a>
                                    <br/>
                                    <a href="/api/ObjectStatus/Home">Statuses</a>
                                    <br/>
                                    <a href="/api/ObjectType/Home">Types</a>
                                    <br/>
                                    <a href="/api/PostalCode/Home">ZIP Codes</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </aside>
            </qbo-menu>
        </li>
        <li onclick="window.location='/Security/Login.ashx/Logout';">
            <svg class="label"><use href="${component.imagePath}#box-arrow-right"></svg>
            <qbo-popover>
                <h3>Sign out</h3>
                <p>Sign out of the system.</p>
            </qbo-popover>
        </li>
    </menu>
</nav>
    `;
});
let QboMainMenu = class QboMainMenu extends LitElement {
    constructor() {
        super(...arguments);
        this.type = 'defaultLayout';
        this.imagePath = window.qbo4['imagePath'] ?? '/ui/images/qbo-icons.svg';
        this.logoPath = window.qbo4['logoPath'] ?? '/ui/images/qbo-logo-new.svg';
    }
    static { this.styles = [
        qboui
    ]; }
    render() {
        return html `<slot>${mainmenuMap.has(this.type) ? mainmenuMap.get(this.type)(this) : null}</slot>`;
    }
};
__decorate([
    property(),
    __metadata("design:type", Object)
], QboMainMenu.prototype, "type", void 0);
__decorate([
    property({ type: String }),
    __metadata("design:type", Object)
], QboMainMenu.prototype, "imagePath", void 0);
__decorate([
    property({ type: String }),
    __metadata("design:type", Object)
], QboMainMenu.prototype, "logoPath", void 0);
QboMainMenu = __decorate([
    customElement('qbo-mainmenu')
], QboMainMenu);
export { QboMainMenu };
